import React, {Component} from 'react';
import {CKEditor} from "ckeditor4-react";
import ckeditorConfig from "./ckeditorConfig";


class TextEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: props.content
        }
        this.onEditorChange = this.onEditorChange.bind(this);
    }

    onEditorChange = (evt) => {
        this.setState({
            content: evt.editor.getData()
        });
        this.props.listener(this.props.name, evt.editor.getData());
    };

    render() {
        let {content} = this.props.content;
        return (
            <div className="text-editor">
                <div className="editor">
                    {(
                        this.props.updateMod === 'viewUpdate' ||
                        (this.props.mode !== 'update' || content !== undefined)
                    ) && (
                        <CKEditor
                            initData={content}
                            config={ckeditorConfig}
                            onChange={this.onEditorChange}
                            onBlur={(e) => this.props.onBlur({
                                target: {
                                    id: "content",
                                    dataset: {'vdata': "required", 'vlength': "1,500"},
                                    value: content
                                }
                            })}
                            type='classic'
                            onPluginsLoaded={(args) => {
                                const editor = args.editor;
                                editor.ui.addRichCombo("my-combo", {
                                    label: "Merge Codes",
                                    title: "Merge Codes",
                                    toolbar: "basicstyles,0",
                                    onClick: function (value) {
                                        editor.focus();
                                        editor.fire("saveSnapshot");
                                        editor.insertHtml(value);
                                        editor.fire("saveSnapshot");
                                    }
                                });
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default TextEditor;
